////declare global {
////	interface Window {
////		saveAs: any
////	}
////}
(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("accountCertificates", {
        templateUrl: "app/account/certificates/accountCertificates.component.html",
        controller: ["myAccountResource", "frameworkService", "messageService", "$http", "$localStorage", "$timeout", "$translate", "$uibModal", "$window", "_", AccountCertificatesCtrl],
        controllerAs: "vm"
    });
    function AccountCertificatesCtrl(myAccountResource, frameworkService, messageService, $http, $localStorage, $timeout, $translate, $uibModal, $window, _) {
        var vm = this;
        vm.ceCreditsEnabled = frameworkService.data.tenantFeatures.ceCredits;
        vm.filteredCerts = [];
        vm.downloadCertificate = downloadCertificate;
        vm.print = print;
        vm.reloadTable = reloadTable;
        vm.openMyTranscriptModal = openMyTranscriptModal;
        vm.$onInit = function () {
            vm.years = [];
            vm.totalCEContactHours = 0;
            if ($localStorage.myCertificatesFilters) {
                vm.filters = $localStorage.myCertificatesFilters;
            }
            else {
                vm.filters = {
                    year: { enabled: true, value: "" },
                    pathName: { enabled: true, value: "" }
                };
            }
            load();
        };
        ///////////////////////////////////////////////////////////
        function load() {
            myAccountResource.getAccountCertificatesViewModel(function (data) {
                vm.certificates = data.certificates;
                var dates = data.certificates.map(function (_a) {
                    var completedDate = _a.completedDate;
                    return moment(completedDate).year();
                }).sort(function (a, b) { return b - a; });
                vm.years = _.uniq(dates, true);
                filterCerts();
            });
        }
        function downloadCertificate(btn, id, name) {
            if (btn.target.disabled) {
                console.log("disabled");
                return;
            }
            btn.target.disabled = true;
            var translations = {
                certificateOfCompletionLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.certificateOfCompletion"),
                hasSuccessfullyCompletedLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.hasSuccessfullyCompleted"),
                registrationNumberLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.registrationNumber"),
                completionDateLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.completionDate"),
                expiryDateLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.expiryDate"),
                LearningPathName: name
            };
            var url = "api/account/certificates/" + id;
            $http.post(url, translations, { responseType: "arraybuffer" })
                .then(function (result) {
                $timeout(function () {
                    //var blob = new Blob([result.data], { type: "application/pdf" });
                    //Chrome for iOS has problems with blobs...
                    //Issue logged on: https://github.com/eligrey/FileSaver.js/issues/179
                    //saveAs(blob, "certificate.pdf");
                    //https://stackoverflow.com/questions/24485077/how-to-open-blob-url-on-chrome-ios
                    var blob = new Blob([result.data], { type: "application/pdf" });
                    if ($window.navigator.userAgent.match("CriOS")) {
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            $window.open(reader.result);
                        };
                        reader.readAsDataURL(blob);
                    }
                    else {
                        window.saveAs(blob, "certificate.pdf");
                    }
                    btn.target.disabled = false;
                });
            }, function () {
                messageService.error("common.genericError");
                btn.target.disabled = true;
            });
        }
        function openMyTranscriptModal() {
            $uibModal.open({
                templateUrl: "app/account/transcript/transcriptView.html",
                controller: "TranscriptCtrl as vm",
                backdrop: "static"
            }).result.catch(angular.noop);
        }
        function print() {
            window.print();
        }
        function reloadTable() {
            vm.totalCEContactHours = 0;
            $localStorage.myCertificatesFilters = vm.filters;
            filterCerts();
        }
        vm.refreshFilter = function (value) {
            $localStorage.myCertificatesFilters = vm.filters;
            //// reload only if filtered
            if (value && value.length > 0)
                filterCerts();
        };
        vm.closeFilter = function (filter) {
            vm.filters[filter].enabled = false;
            vm.refreshFilter(vm.filters[filter].value);
        };
        function filterCerts() {
            setTimeout(function () {
                vm.filteredCerts = _.filter(vm.certificates, function (cert) {
                    var include = true;
                    if (vm.filters.year.enabled && vm.filters.year.value.length > 0) {
                        include = _.includes(vm.filters.year.value, moment(cert.completedDate).utc().year());
                    }
                    if (include) {
                        if (vm.filters.pathName.enabled && vm.filters.pathName.value.length > 0)
                            include = cert.name.toLowerCase().includes(vm.filters.pathName.value.toLowerCase());
                    }
                    return include;
                });
            });
        }
        //function yearFilter(cert) {
        //	if (vm.filters.year.enabled) {
        //		if (vm.filters.year.value.length > 0)
        //			return _.includes(vm.filters.year.value, moment(cert.completedDate).utc().year());
        //		else
        //			return true;
        //	} else {
        //		return true;
        //	}
        //}
        //function pathFilter(cert) {
        //	console.log(cert.name);
        //	if (vm.filters.pathName.enabled) {
        //		if (vm.filters.pathName.value.length > 0)
        //			return cert.name.contains(vm.filters.pathName.value);
        //		else
        //			return true;
        //	} else {
        //		return true;
        //	}
        //}
    }
}());
